import React, { useState, useEffect, useCallback } from "react";
import { FaSearch } from "react-icons/fa";
import { getSalesSlice } from "../../../store/slices/sales";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import styles from "../invoice/Invoice.module.scss";
import Table from "../../common/Table/table";

const Receipt = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    sales,
    searchMessage,
    currentPage,
    totalPages,
    totalCount,
    isLoading,
  } = useSelector((state) => state.sales);
  const { token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const [pageLimit, setPageLimit] = useState(10);

  const [reportFromData, setReportFromData] = useState({
    fromDate: "",
    toDate: "",
  });

  const [searchValue, setSearchValue] = useState("");
   const clinicId =clinicInfo?.[0]?.clinicId ||null;
  const fetchReceipts = useCallback(
    (
      page = 1,
      lim = pageLimit,
      fromDate = reportFromData.fromDate,
      toDate = reportFromData.toDate,
      patientName = searchValue
    ) => {
      if (clinicId && token) {
        dispatch(
          getSalesSlice({
            clinicId,
            fromDate,
            toDate,
            paymentStatus: ["PAID", "DUE"],
            patientName: patientName || undefined,
            currentPage: page,
            limit: lim,
            token,
          })
        );
      }
    },
    [
      dispatch,
      clinicId,
      token,
      pageLimit,
      reportFromData.fromDate,
      reportFromData.toDate,
      searchValue,
    ]
  );

  useEffect(() => {
    fetchReceipts();
  }, [fetchReceipts]);

  const handlePageChange = (page) => {
    fetchReceipts(page, pageLimit);
  };

  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchReceipts(1, newLimit);
  };

  const handleFilter = () => {
    fetchReceipts(1, pageLimit);
  };

  const handleClear = async () => {
    setReportFromData({ fromDate: "", toDate: "" });
    setSearchValue("");
    fetchReceipts(1, pageLimit, "", "", "");
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    fetchReceipts(1, pageLimit, reportFromData.fromDate, reportFromData.toDate, value);
  };

  const handleEdit = (receiptId) => {
    navigate(`/receiptForm`);
    sessionStorage.setItem("receiptId", receiptId.id);
  };

  // const handlePrint = (receiptId) => {
  //   navigate(`/viewReceipt`);
  //   sessionStorage.setItem("receiptId", receiptId.id);
  // };
const handlePrint = (receiptId) => {
  navigate(`/receipt-report-pdf`); 
  sessionStorage.setItem("receiptId", receiptId.id);
};

  const tableHead = [
    { title: "ReceiptId", key: "receiptId" },
    { title: "Patient Name", key: "name" },
    { title: "ApptId", key: "apptId" },
    { title: "Appt Date", key: "apptDate" },
    { title: "Status", key: "status" },
    { title: "Amount", key: "amount" },
  ];

  return (
    <>
      <div className="row">
        <div className="col-md-3">
          <div className="form-group form-focus focused">
            <label className="focus-label">From</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.fromDate}
                onChange={(e) =>
                  setReportFromData({
                    ...reportFromData,
                    fromDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group form-focus focused">
            <label className="focus-label">To</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.toDate}
                onChange={(e) =>
                  setReportFromData({
                    ...reportFromData,
                    toDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>

        <div className="col-md-3 mt-2">
          <button className="btn btn-primary mt-3" onClick={handleFilter}>
            Filter
          </button>
          <button className="btn btn-danger mt-3 ms-3" onClick={handleClear}>
            Clear
          </button>
        </div>

        <div className={classNames("col-md-3", "mt-4", styles["search-area"])}>
          <input
            type="text"
            className={classNames("form-control", styles["search-input"])}
            placeholder="Search here"
            value={searchValue}
            onChange={handleSearchChange}
          />
          <div className="input-group-append">
            <FaSearch />
          </div>
        </div>
      </div>

      <Table
        tableHead={tableHead}
        tableBody={
          Array.isArray(sales)
            ? sales.map((item) => ({
                id: item?._id,
                receiptId: item?.receiptId || "N/A",
                name:
                  item?.invoiceId?.[0]?.appointmentDetails?.patientName || "N/A",
                apptId:
                  item?.invoiceId?.[0]?.appointmentDetails?.appointmentId || "N/A",
                apptDate:
                  item?.invoiceId?.[0]?.appointmentDetails?.appDate?.split("T")[0] ||
                  "N/A",
                status: item?.invoiceId?.[0]?.paymentStatus || "N/A",
                amount: item?.invoiceId?.[0]?.totalAmount || "N/A",
              }))
            : []
        }
        errorMessage={searchMessage}
        handleEdit={handleEdit}
        handlePrint={handlePrint}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        isLoading = {isLoading}
      />
    </>
  );
};

export default Receipt;
